import axios from "axios";

export const axiosInstance = axios.create({
  // TODO: ADD ENV VARIABLES
  // TODO: DELETE LOCAL BACKEND
  // baseURL: "http://localhost:5000/api/v1",
  baseURL: "https://api.savewithempathy.se/api/v1",
});
